import Index from "./pages/Index";

export default function AutoScanApp() {
  return <Index />;
}
